import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";
import { CurrencyCircleDollar, ArrowRight } from "@phosphor-icons/react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FAFAFA]">
      {/* Left panel */}
      <div className="hidden lg:flex flex-col justify-between bg-[#09090B] p-12 relative overflow-hidden grain">
        <div className="flex items-center gap-2 relative z-10">
          <div className="w-9 h-9 bg-[#002FA7] flex items-center justify-center rounded-sm">
            <CurrencyCircleDollar size={22} weight="bold" className="text-white" />
          </div>
          <span className="font-display font-extrabold text-white text-xl tracking-tight">FiloFinans</span>
        </div>
        <div className="relative z-10">
          <h2 className="font-display text-4xl font-bold text-white tracking-tighter leading-tight">
            Filonuzun finansal<br />kontrolü tek ekranda.
          </h2>
          <p className="text-zinc-400 mt-4 text-sm max-w-md leading-relaxed">
            Gelir, gider, finansman ve nakit akışınızı gerçek zamanlı KPI'larla takip edin. Araç kiralama işinizin tüm mali süreçlerini yönetin.
          </p>
          <div className="grid grid-cols-3 gap-4 mt-10 max-w-md">
            {[
              ["Net Kâr", "Anlık"],
              ["Filo Doluluk", "Canlı"],
              ["Kredi Takibi", "Otomatik"],
            ].map(([a, b]) => (
              <div key={a} className="border-l border-zinc-700 pl-3">
                <div className="font-mono text-lg text-white">{b}</div>
                <div className="text-[11px] uppercase tracking-wider text-zinc-500 mt-1">{a}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="text-[11px] text-zinc-600 relative z-10">© 2026 FiloFinans</div>
      </div>

      {/* Right form */}
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm animate-fade-up" data-testid="login-form">
          <div className="lg:hidden flex items-center gap-2 mb-8">
            <div className="w-9 h-9 bg-[#002FA7] flex items-center justify-center rounded-sm">
              <CurrencyCircleDollar size={22} weight="bold" className="text-white" />
            </div>
            <span className="font-display font-extrabold text-zinc-950 text-xl">FiloFinans</span>
          </div>
          <h1 className="font-display text-3xl font-bold tracking-tighter text-zinc-950">Giriş Yap</h1>
          <p className="text-sm text-zinc-500 mt-1 mb-8">Hesabınıza erişmek için bilgilerinizi girin.</p>

          {error && (
            <div className="mb-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded-sm px-3 py-2" data-testid="login-error">
              {error}
            </div>
          )}

          <label className="block text-xs uppercase tracking-[0.15em] font-semibold text-zinc-500 mb-1.5">E-posta</label>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email"
            className="w-full border border-zinc-300 rounded-sm px-3 py-2.5 text-sm mb-4 focus:outline-none focus:ring-2 focus:ring-[#002FA7] focus:border-transparent transition-shadow"
            placeholder="ornek@sirket.com"
          />

          <label className="block text-xs uppercase tracking-[0.15em] font-semibold text-zinc-500 mb-1.5">Şifre</label>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password"
            className="w-full border border-zinc-300 rounded-sm px-3 py-2.5 text-sm mb-6 focus:outline-none focus:ring-2 focus:ring-[#002FA7] focus:border-transparent transition-shadow"
            placeholder="••••••••"
          />

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full bg-zinc-950 text-white rounded-sm py-2.5 text-sm font-semibold hover:bg-zinc-800 transition-colors duration-150 flex items-center justify-center gap-2 disabled:opacity-60"
          >
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
            {!loading && <ArrowRight size={16} weight="bold" />}
          </button>
        </form>
      </div>
    </div>
  );
}
